import request from '../utils/request';

// 获取栏目列表
export function getColumnList() {
  return request({
    url: '/index/website/column',
    method: 'get',
  });
}

// 根据栏目id获取子栏目
export function getColumnChild(params) {
  return request({
    url: '/index/website/column/child',
    method: 'get',
    params,
  });
}

// 根据栏目id获取栏目详情
export function getColumnDetail(columnId) {
  return request({
    url: '/index/website/column/' + columnId,
    method: 'get',
  });
}
